import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChartLine,
  faCodeBranch,
  faCubes,
  faArrowUpRightFromSquare,
  faBoxArchive,
  faTriangleExclamation,
  faSpinner,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

library.add(
  faChartLine,
  faCodeBranch,
  faCubes,
  faArrowUpRightFromSquare,
  faBoxArchive,
  faTriangleExclamation,
  faSpinner,
  faCircleInfo,
  faGithub,
);
